import SelfcareCartItems from 'components/common/MarchPromo/components/SelfcareCartItems/SelfcareCartItems'
import { GuestsDataContext } from 'components/common/MarchPromo/utils/guestsDataProvider'
import { useGuestsSelfcareCart } from 'components/common/MarchPromo/utils/useGuestsSelfcareCart'
import Step from 'components/global/Step'
import { useContext, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { setDeliveryType } from 'store/order-slice'
import { useSelfcare } from 'store/selfcare-slice/hooks'

const MarchPromoSummary = () => {
    const dispatch = useDispatch()
    const { formatMessage } = useIntl()
    const { removeShipping } = useSelfcare()
    const { cartItems } = useGuestsSelfcareCart()

    const { marchVouchersData } = useContext(GuestsDataContext)

    useEffect(() => {
        removeShipping()
        dispatch(setDeliveryType('email'))
    }, [])

    return (
        <Step
            title={formatMessage({
                id: 'selfcare.steps.caption_summary',
                defaultMessage: '_',
            })}
            isButtonDisabled={
                marchVouchersData.length === 0 || cartItems.length === 0
            }
            isButtonVisible={true}
        >
            <SelfcareCartItems />
        </Step>
    )
}

export default MarchPromoSummary
